module.exports = __webpack_public_path__ + "img/source03_b5.ad013eae.png";